import { onUnmounted } from 'vue';

export function useScrollLock() {
  const lockScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.body.style.overflow = '';
  };

  onUnmounted(() => {
    unlockScroll();
  });

  return { lockScroll, unlockScroll };
}
